import { Country } from '@models';

export const displayNameFormatter = (x: { displayName: string }) =>
  x.displayName;

export const countryNameFormatter = (value: Nullable<Country>) =>
  value ? value.name : '';
